<template>
  <div>
    <div class="d-flex flex-column">
      <v-text-field
          v-model="storeAccount"
          filled
          label="Store Account (eg. 0xdf2DD1A6C07AEb5F5593e9296Ce853193E30373f)"
          color="indigo darken-3"
      ></v-text-field>
      <v-text-field
          filled
          v-model="amount"
          label="USDC Amount (eg. 50)"
          type="number"
          color="indigo darken-3"
          @wheel="$event.target.blur()"
      ></v-text-field>
      <v-textarea
          v-model="remark"
          filled
          label="Remark (eg. invoice id: 12345)"
          color="indigo darken-3"
      ></v-textarea>

      <v-btn
          color="indigo darken-3"
          dark
          class="float-end"
          block
          large
          @click="onPayHandle"
      >
        Pay
      </v-btn>
    </div>

    <v-alert
        type="error"
        dense text
        class="mt-4"
        v-if="!formValidation.isValid"
    >{{formValidation.errorMsg}}</v-alert>

    <payment-dialog
        ref="paymentDialog"
        :storeAccount="storeAccount"
        :paymentAmount="amount"
        :remark="remark"
        v-if="paymentDialogShow"
    >
      <template v-slot:paymentInfo="{storeAccount, paymentAmount, remark}">
        <v-card color="grey lighten-3">
          <v-card-text>
            <div>Store Account : {{storeAccount}}</div>
            <div>Payment Amount : {{paymentAmount}}</div>
            <div>Remark : {{remark}}</div>
          </v-card-text>
        </v-card>
      </template>

<!--      <template v-slot:paymentConfirm="paymentConfirm">-->
<!--        <v-card color="grey lighten-3">-->
<!--          <v-card-text>-->
<!--            <div>Payment Amount : {{paymentConfirm.paymentAmount}}</div>-->
<!--            <div>Store Account : {{paymentConfirm.storeAccount}}</div>-->
<!--            <div>Remark : {{paymentConfirm.remark}}</div>-->
<!--          </v-card-text>-->
<!--        </v-card>-->
<!--      </template>-->
    </payment-dialog>
  </div>
</template>

<script>
import PaymentDialog from "../../../components/PaymentDialog";
import {ethers} from "ethers";
import store from "@/store";

export default {
  name: "AccountPayment",
  components: {
    PaymentDialog
  },
  computed: {
    paymentDialogShow() {
      return store.state.paymentDialogShow
    }
  },
  mounted() {
    if (this.$route.query["storeAccount"]) {
      this.storeAccount = this.$route.query["storeAccount"]
    }
  },
  data() {
    return {
      storeAccount: "",
      amount: null,
      remark: "",
      formValidation: {
        isValid: true,
        errorMsg: ""
      }
    }
  },
  methods: {
    onPayHandle(){
      try {
        if (!ethers.utils.isAddress(this.storeAccount)) {
          throw Error("Invalid store account")
        }
        if (!this.amount) {
          throw Error("Payment amount is required")
        }

        this.formValidation.isValid = true
        store.state.paymentDialogShow = true
      }catch (e) {
        this.formValidation.isValid = false
        this.formValidation.errorMsg = e.message
      }
    }
  }
}
</script>

<style scoped>

</style>